import React, { useState } from 'react'
import aboutImg from '../assets/images/accordion.jpg'
import { accordionData } from '../data'

export default function About() {
    let [activeTab, setActiveTab] = useState(1)
  return (
    <div className="row align-items-center">
        <div className="col-lg-5 col-md-6">
            <img src={aboutImg} className="rounded img-fluid shadow" alt=""/>
        </div>

        <div className="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div className="section-title ms-md-4">
                <h4 className="title mb-4">Build beautiful & modular websites</h4>
                <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                
                <div className="accordion mt-4 pt-2">
                    {accordionData.map((item,index)=>{
                        return(
                            <div className="accordion-item rounded mt-2 border" key={index}>
                                <h2 className="accordion-header">
                                    <button className={`accordion-button border-0 bg-light ${activeTab === item.id ? '' : 'collapsed'}`} onClick={()=>setActiveTab(item.id)}>
                                        {item.title}
                                    </button>
                                </h2>
                                <div id="collapseOne" className={`accordion-collapse border-0 collapse  ${activeTab === item.id ? 'show' : ''}`}>
                                    <div className="accordion-body text-muted">{item.desc}</div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    </div>
  )
}
